import React, { useEffect, useRef, useState } from 'react';
import root from 'react-shadow';
import { Interweave } from 'interweave';
import PropTypes from 'prop-types';
import { logData } from '../../actions/analytics';
import { EVENTS } from '../../constants/noflake/noflakeSchema';
import { store } from '../../store';

export const ShadowContent = ({ promo, id, data }) => {
  const [loaded, setLoaded] = useState(false);
  const shadowRef = useRef(null);

  useEffect(() => {
    if (!shadowRef.current || !loaded) return;
    const { shadowRoot } = shadowRef.current;
    const clickElements = [...shadowRoot.querySelectorAll('[data-click-track]')];

    store.dispatch(
      logData({
        type: EVENTS.VIEW,
        value: promo.id || id,
        data,
      }),
    );

    const handleClick = (elm) => {
      store.dispatch(
        logData({
          type: EVENTS.CLICK,
          value: promo.id || elm.getAttribute('data-click-track') || id,
          data: { ...data, additional_params: elm.getAttribute('data-click-track') },
        }),
      );
    };

    clickElements.forEach((elm) => {
      elm.addEventListener('click', () => handleClick(elm));
    });

    return () => {
      clickElements.forEach((elm) => {
        elm.removeEventListener('click', () => handleClick(elm));
      });
    };
  }, [loaded]);

  return (
    <root.div key={promo?.option} ref={shadowRef} id={id}>
      <Interweave
        content={promo.content}
        noWrap
        onAfterParse={(e) => {
          window.setTimeout(() => {
            setLoaded(true);
          }, 500);
          return e;
        }}
      />
    </root.div>
  );
};

ShadowContent.defaultProps = {
  data: {},
};

ShadowContent.propTypes = {
  promo: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  data: PropTypes.object,
};
